import { PropertyListTable } from './PropertyListTable';

export interface PropertyListItemGeneric {
  id: string;
  title: string;
  status?: string;
  createdAt?: string | Date;
  updatedAt?: string | Date;
  photoUrl?: string | null;
  address?: {
    street?: string;
    no?: string;
    zip?: string;
    city?: string;
  };
  numberOfRooms?: number;
  livingArea?: number;
  buildingYear?: number;
  category?: string;
  price?: number;
  upcomingAppointmentsCount?: number;
  lead?: {
    type?: string;
    name?: string;
    email?: string;
    phone?: string;
    hubspotContactId?: string;
  };
  // Additional properties for CareProperties
  leadStatus?: string;
  hasUpcomingAppointments?: boolean;
  hubspotContactId?: string;
}

export interface PropertyListWrapperProps {
  properties: PropertyListItemGeneric[];
  params: any;
  showEmptyState?: boolean;
  emptyStateTitle?: string;
  emptyStateDescription?: string;
}

/**
 * Simplified Property List Component - Only Table View
 * Verwendet direkt PropertyListTable mit Suchfunktion
 */
export function PropertyListWrapper({
  properties,
  params,
  showEmptyState = true,
  emptyStateTitle = 'Keine Immobilien gefunden',
  emptyStateDescription = 'Es konnten keine Immobilien zum Anzeigen gefunden werden.',
}: PropertyListWrapperProps) {
  return (
    <div className="space-y-4">
      {properties.length === 0 && showEmptyState ? (
        <div className="rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 dark:bg-gray-900 p-8 text-center">
          <p className="font-medium text-gray-900 dark:text-gray-100">
            {emptyStateTitle}
          </p>
          <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
            {emptyStateDescription}
          </p>
        </div>
      ) : (
        <PropertyListTable
          properties={properties}
          params={params}
        />
      )}
    </div>
  );
}
